import lazyScreen from '../utils/lazyScreen';
const SPCSourcingPolicy = lazyScreen(() => import('../pages/spc/SPCSourcingPolicy/index.js'), 'pages/spc/SPCSourcingPolicy/index.js');
const SPCSourcingPolicies = lazyScreen(() => import('../pages/spc/SPCSourcingPolicies/index.js'), 'pages/spc/SPCSourcingPolicies/index.js');
const SPCTransferStatuses = lazyScreen(() => import('../pages/spc/SPCTransferStatuses/index.js'), 'pages/spc/SPCTransferStatuses/index.js');
const SPCPurchaseRules = lazyScreen(() => import('../pages/spc/SPCPurchaseRules/index.js'), 'pages/spc/SPCPurchaseRules/index.js');
const SPCPurchaseStatuses = lazyScreen(() => import('../pages/spc/SPCPurchaseStatuses/index.js'), 'pages/spc/SPCPurchaseStatuses/index.js');
const SPCPurchaseByICRule = lazyScreen(() => import('../pages/spc/SPCPurchaseByICRule/index.js'), 'pages/spc/SPCPurchaseByICRule/index.js');
const SPCPurchaseByARRule = lazyScreen(() => import('../pages/spc/SPCPurchaseByARRule/index.js'), 'pages/spc/SPCPurchaseByARRule/index.js');
const SPCDemandPurchase = lazyScreen(() => import('../pages/spc/SPCDemandPurchase/index.js'), 'pages/spc/SPCDemandPurchase/index.js');
const SPCDemandPurchases = lazyScreen(() => import('../pages/spc/SPCDemandPurchases/index.js'), 'pages/spc/SPCDemandPurchases/index.js');
const SPCDemandTransfer = lazyScreen(() => import('../pages/spc/SPCDemandTransfer/index.js'), 'pages/spc/SPCDemandTransfer/index.js');
const SPCDemandTransfers = lazyScreen(() => import('../pages/spc/SPCDemandTransfers/index.js'), 'pages/spc/SPCDemandTransfers/index.js');
const SPCDemandPlanning = lazyScreen(() => import('../pages/spc/SPCDemandPlanning/index.js'), 'pages/spc/SPCDemandPlanning/index.js');
const SPCDemandPlannings = lazyScreen(() => import('../pages/spc/SPCDemandPlannings/index.js'), 'pages/spc/SPCDemandPlannings/index.js');

var ar = [
    {
        path: '/spc/SPCDemandPlannings',
        component: SPCDemandPlannings
    },
    {
        path: '/spc/SPCDemandPlanning/:code',
        component: SPCDemandPlanning
    },
    {
        path: '/spc/SPCDemandPurchases',
        component: SPCDemandPurchases
    },
    {
        path: '/spc/SPCDemandPurchase/:code',
        component: SPCDemandPurchase
    },
    {
        path: '/spc/SPCDemandTransfers',
        component: SPCDemandTransfers
    },
    {
        path: '/spc/SPCDemandTransfer/:code',
        component: SPCDemandTransfer
    },
    {
        path: '/spc/SPCSourcingPolicies',
        component: SPCSourcingPolicies
    },
    {
        path: '/spc/SPCSourcingPolicy/:code',
        component: SPCSourcingPolicy
    },
    {
        path: '/spc/SPCTransferStatuses',
        component: SPCTransferStatuses
    },
    {
        path: '/spc/SPCPurchaseRules',
        component: SPCPurchaseRules
    },
    {
        path: '/spc/SPCPurchaseByICRule/:code',
        component: SPCPurchaseByICRule
    },
    {
        path: '/spc/SPCPurchaseStatuses',
        component: SPCPurchaseStatuses
    },
    {
        path: '/spc/SPCPurchaseByARRule/:code',
        component: SPCPurchaseByARRule
    }
];

export default ar;
